import { Highlight } from '@curology/ui-components-web/react/Highlight';
import { Typography } from '@curology/ui-components-web/react/Typography';
import React from 'react';

import { type Card } from '@/types/productSelectionAndCheckout/types';

import { IngredientsAccordion } from '../IngredientsAccordion';
import { ModalImage } from '../ModalImage';
import { ModalPricingVolumeAndProductOptionSelector } from '../ModalPricingVolumeAndProductOptionSelector';

export const DayPrimeModalContent = ({ modalCard }: { modalCard: Card }) => {
  const { modal } = modalCard;

  return (
    <>
      <ModalImage modal={modal} />
      <Typography className="cur-mt-4" size="h2">
        DayPrime<sup>Rx</sup>
      </Typography>
      <Typography className="cur-mt-4" weight="bold">
        Acne Treatment + Blurring Primer
      </Typography>
      <ModalPricingVolumeAndProductOptionSelector
        className="cur-mt-1"
        modalCard={modalCard}
      />
      {modalCard.recommendationText && (
        <Highlight className="cur-mt-4" state="success">
          <div
            dangerouslySetInnerHTML={{
              __html: modalCard.recommendationText.modalCallout,
            }}
          ></div>
        </Highlight>
      )}
      <Typography className="cur-mt-4" size="h3">
        Why it&apos;s special
      </Typography>
      <Typography className="cur-mt-4">
        Introducing the first-ever prescription acne treatment and blurring
        primer in one.
      </Typography>
      <Typography className="cur-mt-4">
        Treat your acne with clinically proven active ingredients, while the
        primer base instantly improves the appearance of your skin at the same
        time. Formulated to visibly blur imperfections, minimize the look of
        pores, and even out texture. A soft-focus finish today, clearer-looking
        skin in the days ahead.
      </Typography>
      <Typography className="cur-mt-4">
        A licensed dermatology provider selects 3 active ingredients for your
        DayPrimeᴿˣ at the right strength for your skin.
      </Typography>
      <Typography className="cur-mt-4">
        A licensed dermatology provider selects 3 active ingredients for your
        DayPrimeᴿˣ at the right strength for your skin.
      </Typography>
      <Typography className="cur-mt-4" size="h3">
        How to use it
      </Typography>
      <Typography className="cur-mt-4">
        Apply a thin layer of your DayPrime<sup>Rx</sup> to your face once daily
        in the morning after you cleanse and moisturize your skin. Follow up
        with sunscreen to protect from the sun and add makeup on top.
      </Typography>
      <Typography className="cur-mt-4" size="h3">
        Potential active ingredients
      </Typography>
      <IngredientsAccordion
        body="Gently exfoliates to help unclog pores, smooth texture, and brighten skin"
        title="Azelaic acid"
      />
      <IngredientsAccordion
        body="Fights acne-contributing bacteria and soothes inflammation"
        title="Clindamycin phosphate"
      />
      <IngredientsAccordion
        body="Soothes inflammation, helps visibly fade dark spots, and fights free radicals"
        title="Niacinamide"
      />
      <IngredientsAccordion
        body="Soothes inflammation and acts against both bacteria and fungus that contribute to acne"
        title="Zinc pyrithione"
      />
      <IngredientsAccordion
        body="Goes deep into pores to clear away dead skin cells and excess oil"
        title="Salicylic acid"
      />
      <IngredientsAccordion
        body="Attracts and holds moisture for softer, smoother skin"
        title="Dexpanthenol"
      />

      <Typography className="cur-mt-4" size="h3">
        Inactive ingredients
      </Typography>
      <Typography className="cur-mt-4">
        1,2-hexanediol, butylene glycol, caprylyl glycol, ceramide NP, cetearyl
        olivate, dimethicone, glycerin, hydroxyacetophenone, oryza sativa (rice)
        starch, polyacrylate crosspolymer-6, polyhydroxystearic acid, polymethyl
        methacrylate, polymethylsilsesquioxane, polysorbate 20, PVP, sorbitan
        olivate, trisodium ethylenediamine disuccinate, water (aqua)
      </Typography>
      <Typography className="cur-mt-4">
        Formulas containing dexpanthenol also contain propylene glycol.
      </Typography>
    </>
  );
};
